/**
 * ATM ELT product form — vendor-based required fields (ACK vs Kannad/Artex).
 * Matches ATS elt-form.js property names for order export.
 */
(function () {
  function eltMfrFromVendor(vendor) {
    const v = (vendor || '').toLowerCase();
    if (v.includes('ack')) return 'ack';
    return 'kannad_artex';
  }

  function init(block) {
    if (block.dataset.atmEltInitialized === 'true') return;
    block.dataset.atmEltInitialized = 'true';

    const vendor = block.dataset.eltVendor || '';
    const mfr = eltMfrFromVendor(vendor);
    const isAck = mfr === 'ack';
    const isOptional = block.dataset.atmEltRequirement === 'optional';

    const toggle = block.querySelector('[data-atm-elt-toggle]');
    const fields = block.querySelector('[data-atm-elt-fields]');
    const enabledInput = block.querySelector('[data-atm-elt-enabled]');
    const tailField = block.querySelector('[data-atm-elt-tail]');
    const tailInput = block.querySelector('[data-atm-elt-aircraft]');
    const tailReq = block.querySelector('[data-atm-elt-tail-req]');
    const countryInput = block.querySelector('[data-atm-elt-country]');
    const hexInput = block.querySelector('[data-atm-elt-hex]');
    const snInput = block.querySelector('[data-atm-elt-sn]');
    const hint = block.querySelector('[data-atm-elt-mfr-hint]');

    const hintAck =
      block.dataset.mfrHintAck ||
      'For ACK units we need country of operation and 24-bit aircraft address.';
    const hintKannad =
      block.dataset.mfrHintKannad ||
      'For Kannad and Artex units we need tail number, country of operation and 24-bit aircraft address.';

    const noFlag = block.querySelector('[data-atm-elt-no]');
    const choices = block.querySelectorAll('[data-atm-elt-choice]');

    function apply(enabled) {
      if (noFlag) noFlag.disabled = enabled;
      if (fields) {
        fields.hidden = !enabled;
        fields.disabled = !enabled;
      }
      if (enabledInput) enabledInput.disabled = !enabled;

      if (tailField) tailField.hidden = enabled && isAck;
      if (tailReq) tailReq.hidden = enabled && isAck;

      if (tailInput) {
        tailInput.required = false; /* only country of operation is required (2026-10-20) */
        tailInput.disabled = !enabled || isAck;
        if (isAck) tailInput.value = '';
      }
      if (countryInput) countryInput.required = enabled;
      if (hexInput) hexInput.required = false;
      if (snInput) snInput.required = enabled;

      if (hint) {
        hint.textContent = isAck ? hintAck : hintKannad;
        hint.hidden = !enabled;
      }
    }

    // Clear the add-to-cart "required" error once the customer edits a field.
    block.addEventListener('input', (event) => {
      const field = event.target;
      if (!field || typeof field.setCustomValidity !== 'function') return;
      field.setCustomValidity('');

      const productForm = field.form && field.form.closest('product-form');
      if (productForm && typeof productForm.handleErrorMessage === 'function') {
        productForm.handleErrorMessage();
      }
    });

    if (isOptional && toggle) {
      toggle.addEventListener('change', () => apply(toggle.checked));
      apply(toggle.checked);
    } else if (choices.length) {
      /* Required mode with a "no programming" choice (2026-10-20). */
      const current = () => {
        const c = block.querySelector('[data-atm-elt-choice]:checked');
        return !c || c.value === 'yes';
      };
      choices.forEach((c) => c.addEventListener('change', () => apply(current())));
      apply(current());
    } else {
      apply(true);
    }
  }

  function boot() {
    document.querySelectorAll('[data-atm-elt-programming]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-atm-elt-programming]').forEach(init);
  });
})();
